<template>
	<li v-if="activeItem === index">
		<slot />
	</li>
</template>

<script>
export default {
	props: {
		index: {
			type: Number,
			default: -1,
		},
		activeItem: {
			type: Number,
			default: -2,
		},
	},
};
</script>
